import { ACTIONS } from '@/store/action-types'
export const albumCatalogAddViewModel = {
  name: 'AlbumCatalogAdd',
  computed: {
    isError: function () {
      return this.$store.state.configs.parameterError
    },
    isDevelop () {
      if (process.env.NODE_ENV === 'development') {
        return true
      }
      return false
    }
  },
  methods: {
    add () {
      var checkFlag = true;
      var albumCatalogName = this.albumCatalogName === '' ? null : this.albumCatalogName;
      if (albumCatalogName == null) {
        $('#albumCatalogAddNameErr').text('※カテゴリ名をご入力ください！');
        checkFlag = false;
      } else {
        $('#albumCatalogAddNameErr').text('');
        var params = {userId: this.$store.state.myapp.userName, name: this.albumCatalogName};
        $.ajax({
          //url: 'http://localhost:8080/myapp-backend/api/albumCatalog/exists',
          url: '/myapp-backend/api/albumCatalog/exists',
          type: 'POST',
          async:false, 
          context: this,
          data: JSON.stringify(params),
          processData: false,
          contentType : 'application/json;charset=UTF-8',
          success: function (exists) {
            if (exists) {
              $('#albumCatalogAddNameErr').text('※このカテゴリ名は既に存在します！');
              checkFlag = false;
            } else {
              $('#albumCatalogAddNameErr').text('');
            }
          },
          error: function () {
            checkFlag = false;
          }
        });
      }
      if(checkFlag){
        $.ajax({
          //url: 'http://localhost:8080/myapp-backend/api/albumCatalog/add',
          url: '/myapp-backend/api/albumCatalog/add',
          type: 'POST',
          async:false, 
          context: this,
          data: JSON.stringify(params),
          processData: false,
          contentType : 'application/json;charset=UTF-8',
          success: function () {
            this.$router.push('AlbumCatalog');
          }
        });
      }
    }
  }
}
export default {
  albumCatalogAddViewModel
}



// WEBPACK FOOTER //
// ./src/view-model/AlbumCatalogAdd.js